/* Copyright (c) 2025 Xperi. All Rights Reserved. */

/**
 * ErrorCodeTypes enum represents various error types that can occur in the application.
 *
 * Error codes are categorized into:
 * - Network errors (N6xx): Connection, server, and network-related issues
 * - Service context errors (S6xx): Authentication, authorization, and service-level issues
 * - HTTP errors (G4xx-G6xx): Standard HTTP status code related errors
 */
export enum ErrorCodeTypes {
    // Network errors (N6xx range)
    UNKNOWN_SERVER = 'UNKNOWN_SERVER',
    CONNECTION_REFUSED = 'CONNECTION_REFUSED',
    CONNECTION_FAILED = 'CONNECTION_FAILED',
    HTTP_BAD_REQUEST = 'HTTP_BAD_REQUEST',
    BAD_RESPONSE = 'BAD_RESPONSE',
    SHORT_RESPONSE = 'SHORT_RESPONSE',
    IO = 'IO',
    FILE_NOT_FOUND = 'FILE_NOT_FOUND',
    GENERAL = 'GENERAL',

    // Service context errors (S6xx range)
    BRIDGEKEEPER_CONNECTION_DENIED = 'BRIDGEKEEPER_CONNECTION_DENIED',
    SERVICE_CONTEXT_CONNECTION_FAILED = 'SERVICE_CONTEXT_CONNECTION_FAILED',
    CONNECTION_LOST = 'CONNECTION_LOST',
    INVALID_RESPONSE = 'INVALID_RESPONSE',
    SERVICE_CONTEXT_INTERNAL_ERROR = 'SERVICE_CONTEXT_INTERNAL_ERROR',
    CREDENTIAL_FAILED = 'CREDENTIAL_FAILED',
    CREDENTIAL_EXPIRED = 'CREDENTIAL_EXPIRED',
    CREDENTIAL_NOT_AUTHORIZED = 'CREDENTIAL_NOT_AUTHORIZED',
    FAILURE_RETRIEVE_DEVICE_LIST = 'FAILURE_RETRIEVE_DEVICE_LIST',
    NO_AUTHENTICATE_RESPONSE = 'NO_AUTHENTICATE_RESPONSE',
    SERVICE_CONTEXT_MIDDLEMIND_ERROR = 'SERVICE_CONTEXT_MIDDLEMIND_ERROR',
    TIMEOUT = 'TIMEOUT',
    SERVER_NOT_RESOLVED = 'SERVER_NOT_RESOLVED',
    INVALID_CONTEXT_STATE = 'INVALID_CONTEXT_STATE',
    CONTEXT_DESTROYED = 'CONTEXT_DESTROYED',
    SCHEMA_EXCEPTION = 'SCHEMA_EXCEPTION',
    INVALID_ACCESS_TOKEN = 'INVALID_ACCESS_TOKEN',
    REQUEST_CONTEXT_ERROR = 'REQUEST_CONTEXT_ERROR',

    // HTTP errors (G4xx-G6xx range)
    BAD_REQUEST = 'BAD_REQUEST',
    NOT_AUTHORIZED = 'NOT_AUTHORIZED',
    FORBIDDEN = 'FORBIDDEN',
    OBJECT_NOT_FOUND = 'OBJECT_NOT_FOUND',
    NOT_ALLOWED = 'NOT_ALLOWED',
    CONFLICT = 'CONFLICT',
    UNSUPPORTED_MEDIA_TYPE = 'UNSUPPORTED_MEDIA_TYPE',
    TOO_MANY_REQUESTS = 'TOO_MANY_REQUESTS',
    INTERNAL_ERROR = 'INTERNAL_ERROR',
    BAD_GATEWAY = 'BAD_GATEWAY',
    SERVICE_UNAVAILABLE = 'SERVICE_UNAVAILABLE',
    SERVER_TIMEOUT = 'SERVER_TIMEOUT',
    UNHANDLED_ERROR = 'UNHANDLED_ERROR',
}
